import { MobXProviderContext, observer } from 'mobx-react';
import React, { useMemo } from 'react';
import { RootStoreProps } from 'Stores/RootStore.types';
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuItem,
  SidebarSeparator,
} from '~/lib/ui/sidebar';
import { Tooltip, TooltipContent, TooltipTrigger } from '~/lib/ui/tooltip';
import { ContactDetailsSourceProps } from './index.types';

export const ContactDetailsSource = observer(
  ({ contact, showSeparator }: ContactDetailsSourceProps) => {
    const { person: personStore } = React.useContext(
      MobXProviderContext
    ) as RootStoreProps;

    const source = useMemo(() => {
      if (contact.source === 'Nylas') {
        return personStore.getSourceById(contact.sourceData.accountId);
      }
      return null;
    }, [contact, personStore]);

    // If it's not a Nylas contact, return null
    if (!source) {
      return null;
    }

    return (
      <>
        {showSeparator && (
          <div className="px-3.5">
            <SidebarSeparator />
          </div>
        )}
        <SidebarGroup className="px-[7px] pb-4">
          <SidebarGroupLabel className="pb-4">Source</SidebarGroupLabel>
          <SidebarMenu className="px-0">
            <SidebarMenuItem className="px-2 flex gap-2 overflow-hidden">
              <img
                src={personStore.mapProperLogoProvide(
                  source?.sourceData.type,
                  true
                )}
                className="w-4.5 h-4.5"
              />
              <Tooltip>
                <TooltipTrigger asChild>
                  <span className="overflow-hidden text-ellipsis">
                    {source.email}
                  </span>
                </TooltipTrigger>
                <TooltipContent>
                  <p>{source.email}</p>
                </TooltipContent>
              </Tooltip>
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarGroup>
      </>
    );
  }
);
